import { createFileRoute } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowRight, MessageCircle, Github, Twitter } from 'lucide-react';

export const Route = createFileRoute('/community')({
  component: CommunityPage,
});

const communityLinks = [
  { icon: MessageCircle, title: 'Discord', description: 'Join our Discord server for real-time discussions and support.', href: 'https://discord.gg/forgenetwork', members: 'Join the conversation' },
  { icon: Github, title: 'GitHub', description: 'Star our repos, report issues, and contribute to the project.', href: 'https://github.com/forgenetwork', members: 'Open source' },
  { icon: Twitter, title: 'Twitter / X', description: 'Follow us for product updates and engineering insights.', href: 'https://twitter.com/forgenetwork', members: 'Stay updated' },
];

function CommunityPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <Badge variant="secondary" className="mb-4">Community</Badge>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">Join the ForgeNetwork Community</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Connect with developers and help shape the future of code intelligence.
            </p>
          </div>
          <section className="mb-24">
            <div className="grid gap-6 md:grid-cols-3 max-w-4xl mx-auto">
              {communityLinks.map((community) => {
                const Icon = community.icon;
                return (
                  <Card key={community.title} className="hover:shadow-lg transition-shadow">
                    <CardHeader>
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                          <Icon className="h-6 w-6 text-primary" />
                        </div>
                        <div>
                          <CardTitle className="text-lg">{community.title}</CardTitle>
                          <p className="text-sm text-muted-foreground">{community.members}</p>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <CardDescription className="mb-4">{community.description}</CardDescription>
                      <Button variant="outline" asChild>
                        <a href={community.href} target="_blank" rel="noopener noreferrer">Join<ArrowRight className="ml-2 h-4 w-4" /></a>
                      </Button>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </section>
          <section>
            <Card className="bg-gradient-to-br from-primary/10 to-transparent border-primary/20 max-w-2xl mx-auto">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Stay in the Loop</h2>
                <p className="text-muted-foreground max-w-xl mx-auto mb-6">Get the latest updates delivered to your inbox.</p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
                  <input type="email" placeholder="Enter your email" className="flex-1 px-4 py-2 border rounded-md bg-background" />
                  <Button>Subscribe</Button>
                </div>
              </CardContent>
            </Card>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
